module.exports = __webpack_public_path__ + "media/images/talent/lp/case08-47b9bfe2d841aefea3c09ac4430224c3.png";